import { finish, error } from '../../../modules/competitions/actions/save';
import { competitionsSaveCall } from './saveCall';

export function request(dispatch, { data, id }) {
    console.info('SAVE competition request', { data, id });

    competitionsSaveCall({ data, id }).then(
        (competition) => {
            console.info('SAVE competition response', competition);

            dispatch(finish({}));
        },
        ({ errors }) => dispatch(error(errors))
    );
}
